/**
 * The scheduler's failure backoff, client-side.
 *
 * Mirrors `backoffSeconds` in `server/football/scheduler.ts` — 1m, 2m, 4m, … capped at an hour.
 * Duplicated rather than imported because the guard rail forbids anything under `src/` from
 * importing `server/football`, and the alternative — adding it to the status payload for every
 * resource on every poll — ships a derivable number over the wire ten times a minute.
 *
 * The only thing that reads it is the "next attempt in 12m" line, which is the question anyone
 * staring at a failing resource is actually asking.
 */
export function backoffSeconds(consecutiveFailures: number): number {
  if (consecutiveFailures <= 0) return 0
  return Math.min(60 * 60, 60 * 2 ** (consecutiveFailures - 1))
}
